module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-table/~/babel-runtime/core-js/object/assign.js
 ** module id = 1907
 ** module chunks = 3
 **/